/*******************************************************************************
* Licensed Materials - Property of HCL
* (c) Copyright HCL Technologies Ltd. 2020, 2023. All Rights Reserved.

* Note to U.S. Government Users Restricted Rights:
* Use, duplication or disclosure restricted by GSA ADP Schedule
**************************************************************/

import React from "react";
import { useSelector } from "react-redux";
import { Panel, BarChartPanel, Text } from "vr-react-components";
import { DELAY_ANALISYS_ROOM } from "../RoomNameConstants";

const BarPanelAux = React.memo(
    ({ stateName, jobID, title, width, height, ...otherAttributes }) => {
        const canModify = useSelector((state) => state.private.device.canModify);
        const data = useSelector((state) => state[DELAY_ANALISYS_ROOM].jobstreamData[stateName]);

        return data[jobID] &&
            data[jobID].values &&
            data[jobID].values.reduce((p, c) => p + (c.values ? c.values[0] : 0), 0) ? (
            <Panel
                panel
                resize
                title={title}
                enableReload
                width={width}
                height={height}
                backgroundColor="#262626"
                aframeClasses={canModify ? "collidable" : ""}
                {...otherAttributes}
            >
                <BarChartPanel
                    data={data[jobID]}
                    aframeClasses={canModify ? "collidable" : ""}
                />
            </Panel>
        ) : (
            <Panel
                panel
                title={title}
                width={width}
                height={height}
                backgroundColor="#262626"
                aframeClasses={canModify ? "collidable" : ""}
                {...otherAttributes}
            >
                <Text
                    width={width}
                    text="No data available"
                    sizeDecimal={15 / (width / 3)}
                    align="center"
                />
            </Panel>
        );
    },
);

export default BarPanelAux